import { styled } from '@mui/system';

export const SectionWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flex: 1,
  [theme.breakpoints.down('md')]: {
    flexDirection: 'column',
    height: '100%',
    marginRight: 0,
  },
}));

export const SectionContainer = styled('div')(({ theme }) => ({
  padding: '120px 90px',
  display: 'flex',
  alignItems: 'top',
  flex: 1,
  '&:first-of-type': {
    backgroundColor: theme.palette.common.black,
    [theme.breakpoints.down('md')]: {
      display: 'none',
    },
  },
  [theme.breakpoints.down('md')]: {
    display: 'block',
    padding: '120px 20px',
    minHeight: '400px',
    flex: 'none',
  },
}));
